import { normalizeExceptionalCombination } from "./exceptionalCombinations.js";
/**
 * [EN] Alternative word with normalizations in some combinations.
 *
 * [UZ] Ba'zi harf kombinatsiyalari normalizatsiya qilingan muqobil so'z.
 * */

// [EN] Exceptional words' list. This list is not complete. Feel free to send pull request for improvements.
// [UZ] Instisno so'zlar ro'yhati. Ro'yhat to'liq emas. Agar tuzatish kiritishni xohlasangiz bemalol pull-request jonatishingiz mumkin.
export const EXCEPTIONAL_WORDS = {
  ['gramm']: {
    always: ['gramm']
  },
  ['drama']: {
    alternative: normalizeExceptionalCombination('drama', 'dr')
  },
  ['ingliz']: {
    alternative: normalizeExceptionalCombination('ingliz', 'gl')
  },
  ['gramma']: {
    alternative: normalizeExceptionalCombination('gramma', 'gr')
  },
  ['kongress']: {
    always: ['kon', 'gress']
  },
  ['kadr']: {
    always: ['kadr']
  }
};